import { validateEmail, ageGroup } from "sites-common/utils/validations";
import { ageOptions } from "./ageOptions";

export const fieldOverrides = {
  age_group: (r) => ageGroup(r.age),
  whatsapp: (r) => r.mobile,
  country: (r) => r.country?.name,
  state: (r) => r.state?.name,
  aims_id: (r) => r.id,
  uid: (r) => r.user_firebase_uid,
};

const abhyasStageOptions = [
  { name: "a", label: "Practitioner" },
  { name: "n", label: "New Practitioner" },
  { name: "s", label: "Seeker" },
  { name: "t", label: "Trainer" },
];

export const aimsFlds = (config) =>
  [
    { name: "name", label: "Name" },
    {
      name: "ref",
      label: "Heartfulness Id",
      type: "abhyasiid",
      props: { required: false },
    },
    {
      name: "record_type",
      label: "Abhyas Stage",
      type: "select",
      options: abhyasStageOptions,
    },

    { name: "gender", label: "Gender", type: "gender" },
    {
      name: "age_group",
      label: "Age Group",
      type: "select",
      options: ageOptions,
    },

    { name: "city", label: "City" },
    { name: "state", label: "State" },
    { name: "country", label: "Country" },

    { name: "mobile", label: "Mobile", type: "phone" },
    {
      name: "whatsapp",
      label: "Whatsapp",
      type: "phone",
      props: { required: false },
    },
    { name: "email", label: "Email", type: "text", props: { required: false } },
  ].filter(
    (f) =>
      "all" in config ||
      ("aims_flds" in config && config.aims_flds.includes(f.name))
  );

export const visitFlds = (config) =>
  [
    {
      name: "arrival",
      label: "Arrival",
      type: "date",
      props: {
        required: true,
        minDate: config.arrival_mindate,
        maxDate: config.arrival_maxdate,
      },
    },
    {
      name: "departure",
      label: "Departure",
      type: "date",
      props: {
        required: true,
        minDate: config.departure_mindate,
        maxDate: config.departure_maxdate,
      },
    },
    {
      name: "emergency_name",
      label: "Emergency Contact Name",
      props: {
        required: true,
      },
    },
    {
      name: "emergency_no",
      label: "Emergency Contact Phone Number",
      type: "phone",
      props: {
        required: true,
      },
    },
    {
      name: "stay",
      label: "Stay Preference",
      type: "select",
      options: config.stay_options || [
        { name: "tent", label: "Volunteer Tents" },
        { name: "own", label: "Own Arrangements" },
      ],
    },
    {
      name: "vlntr_area",
      label: "Volunteer Areas",
      type: "multiselect",
      options: config.vlntr_area_options || ["Any"],
    },
    {
      name: "vlntr_hours",
      label: "Volunteer Time Availability per day",
      type: "select",
      options: [
        "1 hour",
        "2 hours",
        "3 hours",
        "4 hours",
        "6 hours",
        "8 hours",
        "12 hours",
        "full day",
      ],
    },
  ].filter(
    (f) =>
      "all" in config ||
      ("visit_flds" in config && config.visit_flds.includes(f.name))
  );

export const aimsMandatoryFlds = [
  "name",
  "ref",
  "age",
  "record_type",
  "aims_id",
  "uid",
];

export const userFlds = ["date_added", "uid_added"];

export const fldMap = (config) =>
  [
    ["gender", "age_group"],
    ["city", "state", "country"],
    ["mobile", "whatsapp", "email"],
    ["arrival", "departure"],
    ["emergency_name", "emergency_no"],
    ["vlntr_area", "stay"],
    ["vlntr_hours"],
  ]
    .map((row) =>
      row.filter(
        (col) =>
          config.aims_flds.includes(col) || config.visit_flds.includes(col)
      )
    )
    .filter((row) => row.length > 0);

export const formValidator = (adminConfig) => (r) => {
  if (r.vlntr_area) {
    if (!adminConfig.vlntr_area_allow_multiple) {
      if (Array.isArray(r.vlntr_area) && r.vlntr_area.length > 1) {
        return "Please select only ONE volunteering area";
      }
    }
  }
  if (r.email && !validateEmail(r.email)) {
    return "Invalid Email";
  }
  if (r.arrival && r.departure && r.arrival > r.departure) {
    return "Departure Date cannot be earlier than Arrival Date";
  }
  return false;
};
